(function () {
  if (window.__oddLedgeSound && typeof window.__oddLedgeSound.destroy === "function") {
    window.__oddLedgeSound.destroy();
  }

  const BPM = 128;
  const STEP = 60 / BPM / 2;
  const EIGHT = 16;
  const ENTER_BASS = 4 * EIGHT;
  const ENTER_PIANO = 8 * EIGHT;
  const ENTER_GUITAR = 12 * EIGHT;
  const goat = document.querySelector("[data-goat]");
  const handOn = document.querySelector("[data-goat-hand='on']");
  const handOff = document.querySelector("[data-goat-hand='off']");
  const btn = document.querySelector("[data-music]");
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!btn) return;

  const labelOn = btn.dataset.on || "Sound on";
  const labelOff = btn.dataset.off || "Sound off";
  const abort = new AbortController();

  let ctx = null;
  let master = null;
  let delayGain = null;
  let running = false;
  let starting = false;
  let timer = null;
  let nextTime = 0;
  let step = 0;
  let introTimer = null;
  let pressOnTimer = null;
  let pressOffTimer = null;
  let offPokeTimer = null;
  let introPlayed = false;
  let userTouchedSwitch = false;

  function boot() {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0;
    const comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -16;
    comp.knee.value = 18;
    comp.ratio.value = 3.2;
    comp.attack.value = 0.003;
    comp.release.value = 0.18;
    const delay = ctx.createDelay();
    delay.delayTime.value = 60 / BPM / 2;
    delayGain = ctx.createGain();
    delayGain.gain.value = 0.22;
    delay.connect(delayGain);
    delayGain.connect(delay);
    delayGain.connect(master);
    master.connect(comp);
    comp.connect(ctx.destination);
  }

  function env(gain, t, a, d, peak) {
    gain.gain.cancelScheduledValues(t);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(peak, t + a);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + a + d);
  }

  function kick(t) {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(168, t);
    osc.frequency.exponentialRampToValueAtTime(46, t + 0.09);
    env(g, t, 0.004, 0.22, 1);
    osc.connect(g);
    g.connect(master);
    osc.start(t);
    osc.stop(t + 0.28);
  }

  function hat(t, open) {
    const buffer = ctx.createBuffer(1, 2200, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i += 1) data[i] = Math.random() * 2 - 1;
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const filter = ctx.createBiquadFilter();
    filter.type = "highpass";
    filter.frequency.value = open ? 6200 : 7800;
    const g = ctx.createGain();
    env(g, t, 0.001, open ? 0.12 : 0.035, open ? 0.16 : 0.09);
    src.connect(filter);
    filter.connect(g);
    g.connect(master);
    g.connect(delayGain);
    src.start(t);
    src.stop(t + 0.16);
  }

  function clap(t) {
    const buffer = ctx.createBuffer(1, 3500, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i += 1) data[i] = Math.random() * 2 - 1;
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const filter = ctx.createBiquadFilter();
    filter.type = "bandpass";
    filter.frequency.value = 1800;
    filter.Q.value = 0.7;
    const g = ctx.createGain();
    env(g, t, 0.002, 0.16, 0.22);
    src.connect(filter);
    filter.connect(g);
    g.connect(master);
    src.start(t);
    src.stop(t + 0.2);
  }

  function bass(t, beat, phrase) {
    const roots = [41.2, 41.2, 46.25, 36.71];
    const freq = roots[phrase % roots.length];
    const accent = beat === 0 || beat === 4;
    const saw = ctx.createOscillator();
    const sub = ctx.createOscillator();
    const square = ctx.createOscillator();
    const filter = ctx.createBiquadFilter();
    const g = ctx.createGain();
    saw.type = "sawtooth";
    square.type = "square";
    sub.type = "sine";
    saw.frequency.value = freq;
    square.frequency.value = freq;
    sub.frequency.value = freq;
    square.detune.value = 8;
    filter.type = "lowpass";
    filter.Q.value = accent ? 6 : 3.2;
    filter.frequency.setValueAtTime(accent ? 1100 : 620, t);
    filter.frequency.exponentialRampToValueAtTime(accent ? 160 : 90, t + 0.14);
    env(g, t, 0.003, accent ? 0.2 : 0.11, accent ? 0.38 : 0.26);
    saw.connect(filter);
    square.connect(filter);
    sub.connect(filter);
    filter.connect(g);
    g.connect(master);
    saw.start(t);
    square.start(t);
    sub.start(t);
    saw.stop(t + 0.24);
    square.stop(t + 0.24);
    sub.stop(t + 0.24);
  }

  function stab(t, degree) {
    const chords = [
      [329.63, 392.0, 493.88],
      [329.63, 392.0, 493.88],
      [369.99, 440.0, 554.37],
      [293.66, 440.0, 587.33],
    ];
    const hp = ctx.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 280;
    hp.Q.value = 0.7;
    chords[degree % chords.length].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "sawtooth";
      osc.frequency.value = freq;
      osc.detune.value = i * 6 - 6;
      env(g, t, 0.002, 0.11, 0.13 / (i + 1));
      osc.connect(g);
      g.connect(hp);
      osc.start(t);
      osc.stop(t + 0.16);
    });
    hp.connect(master);
    if (delayGain) hp.connect(delayGain);
  }

  function acid(t, beat, phrase) {
    const seq = [164.81, 196.0, 164.81, 220.0, 246.94, 164.81, 146.83, 196.0];
    const freq = seq[(beat + (phrase % 2) * 3) % seq.length];
    const accent = beat === 0 || beat === 3 || beat === 6;
    const saw = ctx.createOscillator();
    const filter = ctx.createBiquadFilter();
    const g = ctx.createGain();
    saw.type = "sawtooth";
    saw.frequency.value = freq;
    filter.type = "lowpass";
    filter.Q.value = accent ? 14 : 9;
    filter.frequency.setValueAtTime(accent ? 4200 : 2400, t);
    filter.frequency.exponentialRampToValueAtTime(accent ? 320 : 180, t + (accent ? 0.18 : 0.1));
    env(g, t, 0.002, accent ? 0.16 : 0.08, accent ? 0.22 : 0.12);
    saw.connect(filter);
    filter.connect(g);
    g.connect(master);
    if (delayGain) g.connect(delayGain);
    saw.start(t);
    saw.stop(t + 0.2);
  }

  function nod() {
    if (reduce || !goat || !running) return;
    goat.classList.add("is-dancing");
    goat.animate(
      [
        { transform: "translateY(0) rotate(0deg)" },
        { transform: "translateY(14px) rotate(12deg)", offset: 0.32 },
        { transform: "translateY(-3px) rotate(-4deg)", offset: 0.68 },
        { transform: "translateY(0) rotate(0deg)" },
      ],
      { duration: (60 / BPM) * 900, easing: "cubic-bezier(0.22, 1, 0.36, 1)" }
    );
  }

  function tick() {
    if (!running || !ctx) return;
    const horizon = ctx.currentTime + 0.16;
    while (nextTime < horizon) {
      const t = nextTime;
      const beat = step % 8;
      const phrase = Math.floor(step / 8);
      if (beat % 2 === 0) {
        kick(t);
        window.setTimeout(nod, Math.max(0, (t - ctx.currentTime) * 1000));
      }
      if (beat === 2 || beat === 6) clap(t);
      hat(t, beat === 3 || beat === 7);
      if (step >= ENTER_BASS) bass(t, beat, phrase);
      if (step >= ENTER_PIANO && (beat === 2 || beat === 6)) stab(t, Math.floor(step / EIGHT));
      if (step >= ENTER_GUITAR && beat !== 5) acid(t, beat, phrase);
      nextTime += STEP;
      step += 1;
    }
    timer = window.setTimeout(tick, 40);
  }

  function aim(node, fromLeft) {
    if (!node) return null;
    const img = node.querySelector("img");
    if (!img || !img.naturalWidth) return null;
    const prev = node.style.transform;
    node.style.transform = "translate3d(0,0,0)";
    const ir = img.getBoundingClientRect();
    const sw = btn.getBoundingClientRect();
    const tipX = Number(node.dataset.tipX) || 0.257;
    const tipY = Number(node.dataset.tipY) || 0.99;
    const tip = {
      x: ir.left + ir.width * tipX,
      y: ir.top + ir.height * tipY,
    };
    const target = {
      x: sw.left + sw.width / 2,
      y: sw.top + sw.height * 0.55,
    };
    const pressX = target.x - tip.x;
    const pressY = target.y - tip.y;
    node.style.transform = prev;
    const slide = Math.max(36, ir.width * 0.14);
    return {
      pressX,
      pressY,
      restX: pressX + (fromLeft ? -slide : slide),
      restY: pressY - Math.max(220, ir.height * 0.72),
    };
  }

  function reach(node, shot, duration) {
    return node.animate(
      [
        { transform: `translate3d(${shot.restX}px, ${shot.restY}px, 0)`, opacity: 0, offset: 0 },
        { transform: `translate3d(${shot.pressX}px, ${shot.pressY - 22}px, 0)`, opacity: 1, offset: 0.36 },
        { transform: `translate3d(${shot.pressX}px, ${shot.pressY}px, 0)`, opacity: 1, offset: 0.48 },
        { transform: `translate3d(${shot.pressX}px, ${shot.pressY - 8}px, 0)`, opacity: 1, offset: 0.6 },
        { transform: `translate3d(${shot.restX}px, ${shot.restY}px, 0)`, opacity: 0, offset: 1 },
      ],
      { duration, easing: "cubic-bezier(.22, 1, .36, 1)", fill: "forwards" }
    );
  }

  function cancelIntro() {
    window.clearTimeout(introTimer);
    window.clearTimeout(pressOnTimer);
    window.clearTimeout(pressOffTimer);
    window.clearTimeout(offPokeTimer);
    [handOn, handOff].forEach((node) => {
      if (!node) return;
      node.getAnimations().forEach((anim) => anim.cancel());
      node.style.opacity = "0";
    });
  }

  function playIntro() {
    if (introPlayed || userTouchedSwitch || running) return;
    introPlayed = true;
    if (reduce || !handOn) return;
    const shotOn = aim(handOn, false);
    const shotOff = aim(handOff, true);
    if (!shotOn) return;
    const aMove = reach(handOn, shotOn, 2450);
    pressOnTimer = window.setTimeout(() => {
      if (userTouchedSwitch || running) return;
      pokeSwitch();
      syncUi(true);
    }, 1170);
    pressOffTimer = window.setTimeout(() => {
      if (userTouchedSwitch || running) return;
      if (shotOff && handOff) reach(handOff, shotOff, 1680);
    }, 1080);
    offPokeTimer = window.setTimeout(() => {
      if (userTouchedSwitch || running) return;
      pokeSwitch();
      syncUi(false);
    }, 1886);
    aMove.finished.catch(() => {}).then(() => {
      if (handOn) handOn.style.opacity = "0";
    });
  }

  function beginPlayback() {
    if (running) return;
    if (!ctx || ctx.state === "closed") boot();
    const kickOff = () => {
      if (running || !ctx || ctx.state !== "running") return;
      running = true;
      starting = false;
      master.gain.value = 0.22;
      step = 0;
      nextTime = ctx.currentTime + 0.06;
      document.body.classList.add("is-music");
      syncUi(true);
      tick();
    };
    if (ctx.state === "running") {
      kickOff();
      return;
    }
    starting = true;
    ctx.resume().then(() => {
      starting = false;
      kickOff();
    }).catch(() => {
      starting = false;
    });
  }

  async function silence() {
    running = false;
    window.clearTimeout(timer);
    timer = null;
    if (!ctx) return;
    const dying = ctx;
    const gain = master;
    ctx = null;
    master = null;
    delayGain = null;
    try {
      if (gain) {
        const t = dying.currentTime;
        gain.gain.cancelScheduledValues(t);
        gain.gain.setValueAtTime(0, t);
      }
      await dying.close();
    } catch (err) {
      /* already closed */
    }
  }

  async function stop() {
    starting = false;
    await silence();
    document.body.classList.remove("is-music");
    if (goat) goat.classList.remove("is-dancing");
    syncUi(false);
  }

  function syncUi(on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.setAttribute("aria-label", on ? labelOn : labelOff);
    const label = btn.querySelector("[data-music-label]");
    if (label) label.textContent = on ? labelOn : labelOff;
  }

  function pokeSwitch() {
    btn.classList.add("is-poked");
    window.setTimeout(() => btn.classList.remove("is-poked"), 180);
  }

  function unlock() {
    if (!ctx || ctx.state === "closed") boot();
    if (master && !running) master.gain.value = 0;
    if (!ctx) return;
    if (ctx.state === "running") {
      keepAlive();
      return;
    }
    ctx.resume().then(() => keepAlive());
  }

  function keepAlive() {
    if (!ctx || ctx.__oddKeep) return;
    ctx.__oddKeep = true;
    const buf = ctx.createBuffer(1, 2, ctx.sampleRate);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.loop = true;
    const g = ctx.createGain();
    g.gain.value = 0;
    src.connect(g);
    g.connect(ctx.destination);
    src.start();
  }

  function onGesture() {
    unlock();
  }

  function onClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    userTouchedSwitch = true;
    cancelIntro();
    unlock();
    if (running) stop();
    else beginPlayback();
  }

  btn.addEventListener("click", onClick, { signal: abort.signal });
  ["pointerdown", "touchstart", "keydown"].forEach((type) => {
    window.addEventListener(type, onGesture, { capture: true, passive: true, signal: abort.signal });
  });

  const handImgs = [handOn, handOff].map((node) => node && node.querySelector("img")).filter(Boolean);
  Promise.all(
    handImgs.map((img) =>
      img.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          })
    )
  ).then(() => {
    introTimer = window.setTimeout(playIntro, 3000);
  });
  syncUi(false);

  window.__oddLedgeSound = {
    destroy() {
      abort.abort();
      cancelIntro();
      starting = false;
      silence();
      document.body.classList.remove("is-music");
      syncUi(false);
    },
  };
})();
